/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoomout': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="#000" fill-rule="evenodd"><path pid="0" d="M4.199 14.218a7.039 7.039 0 01-2.075-5.01c0-1.892.737-3.67 2.075-5.01a7.039 7.039 0 015.01-2.074c1.892 0 3.67.737 5.009 2.075a7.038 7.038 0 012.075 5.01 7.038 7.038 0 01-2.075 5.009 7.038 7.038 0 01-5.01 2.075 7.038 7.038 0 01-5.01-2.075zm19.714 7.442l-7.165-7.165a9.14 9.14 0 001.669-5.287c0-2.46-.958-4.772-2.697-6.51A9.149 9.149 0 009.208 0c-2.46 0-4.772.958-6.51 2.697A9.148 9.148 0 000 9.208c0 2.46.958 4.773 2.697 6.512a9.148 9.148 0 006.511 2.697 9.14 9.14 0 005.287-1.67l7.165 7.166 2.253-2.253z"/><path pid="1" d="M4.96 10.27h8.496V8.147H4.961z"/></g>'
  }
})
